import { render, staticRenderFns } from "./DispatchDetails.vue?vue&type=template&id=2589ecfa&"
import script from "./DispatchDetails.vue?vue&type=script&lang=js&"
export * from "./DispatchDetails.vue?vue&type=script&lang=js&"
import style0 from "./DispatchDetails.vue?vue&type=style&index=0&id=2589ecfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard});
